import { useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type Document } from '../../api/documents';

export function SearchConsolePage() {
  const [query, setQuery] = useState('');
  const [semantic, setSemantic] = useState(false);
  const [results, setResults] = useState<Document[]>([]);
  const [error, setError] = useState('');

  const search = async () => {
    try {
      const r = await documentsApi.search({ q: query, semantic });
      setResults(r.documents);
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/documents" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Document Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Search Console</h1>
      <div className="mt-6 flex flex-wrap gap-3">
        <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search documents..."
          className="flex-1 rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={semantic} onChange={(e) => setSemantic(e.target.checked)} />
          Semantic
        </label>
        <button onClick={() => void search()}
          className="rounded bg-slate-900 px-4 py-2 text-white dark:bg-slate-100 dark:text-slate-900">
          Search
        </button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-2">
        {results.map((d) => (
          <li key={d.id} className="rounded-lg border p-3 text-sm dark:border-slate-700">
            <span className="font-medium">{d.name}</span>
            <span className="ml-2 text-slate-500 capitalize">{d.category.replace('_', ' ')}</span>
          </li>
        ))}
        {results.length === 0 && query && <li className="text-sm text-slate-500">No results</li>}
      </ul>
    </div>
  );
}
